import React from 'react';
import Navbar from './Navbar';
import Footer from './Footer';
import SEOWrapper from '../SEO/SEOWrapper';

interface LayoutProps {
  children: React.ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  return (
    <SEOWrapper>
      <div className="flex flex-col min-h-screen" style={{ backgroundColor: '#ffffff' }}>
        <Navbar />
        <main className="flex-grow pt-24">{children}</main>
        <Footer />
      </div>
    </SEOWrapper>
  );
};

export default Layout; 